// extracted by mini-css-extract-plugin
export default {"terms-content":"TermsModal_terms-content__2RIJ9"};